// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pwrR","clinicsSelect":"styles_clinicsSelect__1Xlti"};